import Vue from "vue";
export default {
  name: "editorFile",
  props: ["type", "src"],
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {}
};